import { render, staticRenderFns } from "./MedicineRecallInfo.vue?vue&type=template&id=c9586390&scoped=true&"
import script from "./MedicineRecallInfo.vue?vue&type=script&lang=js&"
export * from "./MedicineRecallInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedicineRecallInfo.vue?vue&type=style&index=0&id=c9586390&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9586390",
  null
  
)

export default component.exports